export const SET_MENU_USER_COMPANY = "SET_MENU_USER_COMPANY";
